// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"44416f34","794":"260c5622"}[chunkId] + ".chunk.js";
};